import { parseGitUrl } from '../../utils/helpers/parseGitUrl.esm.js';
import { GithubManager } from './providers/github/githubManager.esm.js';
import { GitlabManager } from './providers/gitlab/gitlabManager.esm.js';

class GitManager {
  constructor(config, githubAuthApi, gitlabAuthApi) {
    this.config = config;
    this.githubAuthApi = githubAuthApi;
    this.gitlabAuthApi = gitlabAuthApi;
  }
  async getAccessToken(location) {
    const url = parseGitUrl(location);
    switch (true) {
      case url.includes("github"): {
        const token = await this.githubAuthApi.getAccessToken([
          "read_user",
          "repo",
          "public_repo",
          "api",
          "read_api",
          "workflow"
        ]);
        return token;
      }
      case url.includes("gitlab"): {
        const token = await this.gitlabAuthApi.getAccessToken([
          "read_user",
          "api",
          "read_api",
          "read_repository",
          "write_repository"
        ]);
        return token;
      }
      default:
        throw new Error("Git provider Auth error: unimplemented!");
    }
  }
  getGithubManager(token) {
    return new GithubManager(this.config, token);
  }
  getGitlabManager(token) {
    return new GitlabManager(this.config, token);
  }
  async createPullRequest(files, location, title, message) {
    const url = parseGitUrl(location);
    switch (true) {
      case url.includes("github"): {
        const token = await this.getAccessToken(location);
        const githubManager = this.getGithubManager(token);
        return githubManager.createPullRequest(files, location, title, message);
      }
      case url.includes("gitlab"): {
        const token = await this.getAccessToken(location);
        const gitlabManager = this.getGitlabManager(token);
        return gitlabManager.createMergeRequest(files, location, title, message);
      }
      default:
        throw new Error("Git provider error: Pull request unimplemented!");
    }
  }
}

export { GitManager };
//# sourceMappingURL=gitManager.esm.js.map
